import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class FallecimientoService {
    constructor(private http: HttpClient) { }

    traePostulantes(rut: any) {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }


    buscarHijo(rut: any) {
        return this.http.get(`${environment.urlApiSubsidio}/nacimiento/registroCivil/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    ingresarFallecimiento(fallecimiento: any, fechaFallecimiento: any, idAfiliado: any,idCarga: any,idUsuarioSesion: any,esRecienNacido: any,beneficiarios: any, idEjecutivo:any) {

        return this.http.post(`${environment.urlApiSubsidio}/solicitud/fallecimiento`,
            {
                idUsuario: idAfiliado,           
                idCarga: idCarga,
                idUsuarioSesion:idUsuarioSesion,
                idProducto: 11,
                archivoAdjunto: fallecimiento.archivo,
                idEjecutivoAsignado:idEjecutivo,
                fallecimiento: {
                    fechaFallecimiento: fechaFallecimiento,
                    rutHijo: fallecimiento.rutHijo,
                    esRecienNacido:esRecienNacido,
                    nombreHijo: fallecimiento.nombreHijo,
                    fallecimientoBeneficiario:beneficiarios
                }

            },
            { headers: this.armaCabecera() }).toPromise();
    }

    editarFallecimiento(data: any, fechaFallecimiento: any, idUsuario: any ,idUsuarioSesion: any) {
        console.log("data:",data)
         return this.http.put(`${environment.urlApiSubsidio}/solicitud/fallecimiento`,
             {
                 idUsuario: idUsuario,
                 id: data.idPostulacion,
                 idProducto: 11,
                 fallecimiento: {                  
                    fechaFallecimiento: fechaFallecimiento,
                    rutHijo: data.rutHijo,
                    nombreHijo: data.nombreHijo,
                    esRecienNacido:data.scales
                 }
             },
             { headers: this.armaCabecera() }).toPromise();
     }
    


    traeTipoFallecimiento() {

        return this.http.get(`${environment.urlApiSubsidio}/getTipoFallecimiento`,
            { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}